import {applyMiddleware, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {ravenMiddleware} from '../raven';
import rootReducer from '../reducers';

export default function configureStore(initialState) {
  return createStore(rootReducer, initialState, applyMiddleware(ravenMiddleware, thunkMiddleware));
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/store/configureStore.prod.js